import React from "react";
import styles from "@/styles/CookiePreferencesButton.module.scss";

const CookiePreferencesButton: React.FC = () => {
	return (
		<button
			type="button"
			data-cc="show-preferencesModal"
			className={styles.button}
		>
			Preferências de cookies
		</button>
	);
};

export default React.memo(CookiePreferencesButton);
